import FlowsNode from './flowsNode/flowsNode';

const autoLayout = (nodes, type = 'vertical', options = {}) => {
    const { 
      startX = 250, 
      startY = 50, 
      xGap = 100,
      yGap = 700,
      horizontalLevels = 3 // For grid layout
    } = options;
    
    // Create a map of nodes by ID for easy access
    const nodeMap = {};
    nodes.forEach(node => {
      nodeMap[node.id] = node;
    });
    
    // Find the root node (node with parent = null)
    const rootNode = nodes.find(node => node.data.parent === null);
    if (!rootNode) return nodes; // Safety check
    
    // Initialize result array with positioned nodes
    const positionedNodes = [];
    
    // Position the root node
    const rootNodeWithPosition = {
      ...rootNode,
      type: 'flowNode',
      position: { x: startX, y: startY }
    };
    positionedNodes.push(rootNodeWithPosition);
    
    // Recursively position all children
    let currentY = startY;
    let remainingNodes = [...(rootNode.data.children || [])];
    
    while (remainingNodes.length > 0) {
      const currentId = remainingNodes.shift();
      const currentNode = nodeMap[currentId];
      
      if (currentNode) {
        currentY = currentY + 220;
        const nodeWithPosition = {
          ...currentNode,
          type: 'flowNode',
          position: { x: startX, y: currentY }
        };
        positionedNodes.push(nodeWithPosition);
        
        // Add this node's children to the queue
        if (currentNode.data.children && currentNode.data.children.length > 0) {
          remainingNodes = [...remainingNodes, ...currentNode.data.children];
        }
      }
    }
    
    return positionedNodes;
  };

export default autoLayout